import React, { useState } from "react";
import customHttp from "../../services/customHTTP"; // Import custom axios instance
import IconButton from "@mui/material/IconButton";
import ViewInArOutlinedIcon from "@mui/icons-material/ViewInArOutlined";
import "./ModelButton.css"; // Import custom CSS for blinking effect
import { Box, Modal, Tooltip, Typography, useTheme } from "@mui/material";
import { useAuth } from "../../context/authContext";
import { useSite } from "../../context/siteContext";
import { SERVER_BASE_URL } from "../../config";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import { useNavigate } from "react-router-dom";
import MultipleModelViewer from "../MultipleModelViewer/MultipleModelViewer";

const ModelButton = ({
	selected_part = "",
	machineName,
	machineNumber,
	machineProductName,
	machineid,
	changeParts = false,
	hasMultiple3DModels = false,
}) => {
	const [loading, setLoading] = useState(false);
	const [CPloading, setCPLoading] = useState(false);
	const { user } = useAuth();
	const { selectedSite, selectedSiteCurrency } = useSite();
	const navigate = useNavigate();
	const theme = useTheme();
	const [modalOpen, setModalOpen] = useState(false);
	const [modalLoading, setModalLoading] = useState(false);

	const style = {
		position: "absolute",
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%)",
		width: "65%",
		bgcolor: "background.paper",
		boxShadow: 24,
		borderRadius: 2,
		p: 2,
		px: 4,
	};
	const handleMultipleModelButtonClick = async () => {
		console.log(machineNumber, " Has Multiple Models");
		setModalOpen(true);
	};

	const handleCloseDialog = () => {
		setModalOpen(false);
		setModalLoading(false);
	};

	const handleButtonClick = async () => {
		setLoading(true); // Show loading state
		console.log(theme);
		try {
			// Make the API call
			const response = await customHttp.get("/models/process-modelfile", {
				params: {
					filename: machineNumber,
					machinename: machineName,
					currency: selectedSiteCurrency.toUpperCase(),
					loggedinUser: user.user_id,
					ecommachineid: machineid,
					baseColor: theme.palette.primary.main,
					selectedSite,
					machinenumber: machineNumber,
				},
			});

			if (response.status === 200) {
				const backendUrl = SERVER_BASE_URL || "";
				const fullUrl = backendUrl + response.data.url; // Construct the full URL
				setLoading(false);
				window.open(fullUrl); // Redirect after 1 second delay
				navigate("/cart");
			}
		} catch (err) {
			console.error("Error fetching the model:", err);
		}
	};

	const handleCPButtonClick = async () => {
		setCPLoading(true); // Show loading state

		try {
			// Make the API call
			const response = await customHttp.get("/models/process-modelfile", {
				params: {
					filename: `${machineNumber}_CP`,
					machinename: machineName,
					currency: selectedSiteCurrency.toUpperCase(),
					loggedinUser: user.user_id,
					ecommachineid: machineid,
					baseColor: theme.palette.primary.main,
					selectedSite,
					machinenumber: machineNumber,
				},
			});
			console.log(response);

			if (response.status === 200) {
				const backendUrl = SERVER_BASE_URL || "";
				const fullUrl = backendUrl + response.data.url; // Construct the full URL
				setCPLoading(false);
				window.open(fullUrl); // Redirect after 1 second delay
				navigate("/cart");
			}
		} catch (err) {
			console.error("Error fetching the model:", err);
		}
	};

	return (
		<>
			<Tooltip title="View 3D Model">
				<IconButton
					aria-label="View 3D Model"
					size="large"
					onClick={(e) => {
						e.stopPropagation();
						e.preventDefault();
						if (hasMultiple3DModels) {
							handleMultipleModelButtonClick();
						} else {
							handleButtonClick();
						}
					}}
					disabled={loading}
					className={loading ? "blinking-icon" : ""}>
					<ViewInArOutlinedIcon />
				</IconButton>
			</Tooltip>
			{changeParts && (
				<Tooltip title="View Change Parts 3D Model">
					<IconButton
						aria-label="View Change Parts 3D Model"
						size="large"
						onClick={(e) => {
							e.stopPropagation();
							e.preventDefault();
							handleCPButtonClick();
						}}
						disabled={CPloading}
						className={CPloading ? "blinking-icon" : ""}>
						<WidgetsOutlinedIcon />
					</IconButton>
				</Tooltip>
			)}
			<MultipleModelViewer
				show={modalOpen}
				setShow={setModalOpen}
				machine_number={machineNumber}
				machine_name={machineName}
				machine_id={machineid}
				machine_product_name={machineProductName}
			/>
		</>
	);
};

export default ModelButton;
